// import React from "react";
// import { useNavigate } from "react-router-dom";
// import { Button, Typography, Card, CardContent, Grid } from "@mui/material";

// const CardPage = () => {
//   const Navigate = useNavigate();
//   const selectedSubject = localStorage.getItem("selectedSubject");

//   const handleTestClick = () => {
//     switch (selectedSubject) {
//       case "FREE":
//         Navigate("/year");
//         break;
//       case "PG":
//         Navigate("/subject");
//         break;
//       case "UG":
//         Navigate("/non_nursing");
//         break;
//       case "NEET":
//         Navigate("/prelims");
//         break;
//       case "TNSET":
//         Navigate("/model");
//         break;
//       default:
//         alert("No valid subject selected.");
//     }
//   };
//   const handlevideoClick = () => {
//     switch (selectedSubject) {
//       case "FREE":
//         Navigate("/freevideos");
//         break;
//       case "PG":
//         Navigate("/pgvideos");
//         break;
//       case "UG":
//         Navigate("/ugvideos");
//         break;
//       case "NEET":
//         Navigate("/neetvideos");
//         break;
//       case "TNSET":
//         Navigate("/tnsetvideos");
//         break;
//       default:
//         alert("No valid subject selected.");
//     }
//   };

//   return (
//     <div style={{ padding: "2rem" }}>
//       <Typography variant="h5" gutterBottom align="center">
//         Selected Subject: {selectedSubject}
//       </Typography>

//       <Grid
//         container
//         spacing={4}
//         justifyContent="center"
//         style={{ marginTop: "2rem" }}
//       >
//         {/* Test Card */}
//         <Grid item xs={12} sm={6} md={4}>
//           <Card sx={{ padding: 2, textAlign: "center", boxShadow: 4 }}>
//             <CardContent>
//               <Typography variant="h6" gutterBottom>
//                 Test Section
//               </Typography>
//               <Typography variant="body2" color="text.secondary">
//                 Start tests based on the selected subject.
//               </Typography>
//               <Button
//                 variant="contained"
//                 color="primary"
//                 onClick={handleTestClick}
//                 sx={{ marginTop: 2 }}
//               >
//                 Go to Test
//               </Button>
//             </CardContent>
//           </Card>
//         </Grid>

//         {/* Video Card */}
//         <Grid item xs={12} sm={6} md={4}>
//           <Card sx={{ padding: 2, textAlign: "center", boxShadow: 4 }}>
//             <CardContent>
//               <Typography variant="h6" gutterBottom>
//                 Video Section
//               </Typography>
//               <Typography variant="body2" color="text.secondary">
//                 Watch videos relevant to the selected subject.
//               </Typography>
//               <Button
//                 variant="contained"
//                 color="secondary"
//                 onClick={handlevideoClick}
//                 sx={{ marginTop: 2 }}
//               >
//                 Go to Videos
//               </Button>
//             </CardContent>
//           </Card>
//         </Grid>
//       </Grid>
//     </div>
//   );
// };

// export default CardPage;


import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Typography, Card, CardContent, Grid } from "@mui/material";

const CardPage = () => {
  const Navigate = useNavigate();
  const selectedSubject = localStorage.getItem("selectedSubject");
  const batchname = localStorage.getItem("batchname"); // Get batchname

  const handleTestClick = () => {
    switch (selectedSubject) {
      case "FREE":
        Navigate("/year");
        break;
      case "PG":
        Navigate("/subject");
        break;
      case "UG":
        Navigate("/non_nursing");
        break;
      case "NEET":
        Navigate("/prelims");
        break;
      case "TNSET":
        Navigate("/model");
        break;
      default:
        alert("No valid subject selected.");
    }
  };

  const handlevideoClick = () => {
    switch (selectedSubject) {
      case "FREE":
        Navigate("/freevideos");
        break;
      case "PG":
        Navigate("/pgvideos");
        break;
      case "UG":
        Navigate("/ugvideos");
        break;
      case "NEET":
        Navigate("/neetvideos");
        break;
      case "TNSET":
        Navigate("/tnsetvideos");
        break;
      default:
        alert("No valid subject selected.");
    }
  };
  console.log(batchname);

  return (
    <div style={{ padding: "2rem" }}>
      <Typography variant="h5" gutterBottom align="center">
        Selected Subject: {selectedSubject}
      </Typography>

      <Grid
        container
        spacing={4}
        justifyContent="center"
        style={{ marginTop: "2rem" }}
      >
        {/* Test Card */}
        <Grid item xs={12} sm={6} md={4}>
          <Card sx={{ padding: 2, textAlign: "center", boxShadow: 4 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Test Section
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Start tests based on the selected subject.
              </Typography>
              <Button
                variant="contained"
                color="primary"
                onClick={handleTestClick}
                sx={{ marginTop: 2 }}
              >
                Go to Test
              </Button>
            </CardContent>
          </Card>
        </Grid>

        {/* Video Card (conditionally shown) */}
        {batchname !== "testbatch" && (
          <Grid item xs={12} sm={6} md={4}>
            <Card sx={{ padding: 2, textAlign: "center", boxShadow: 4 }}>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Video Section
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Watch videos relevant to the selected subject.
                </Typography>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={handlevideoClick}
                  sx={{ marginTop: 2 }}
                >
                  Go to Videos
                </Button>
              </CardContent>
            </Card>
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default CardPage;
